'use client';
import { useEffect } from 'react';
import { useSession } from 'next-auth/react';

/**
 * FCM push registracija — veikia TIK Capacitor programėlėje (Android WebView).
 * Prisijungus paprašo leidimo, gauna FCM token'ą ir atsiunčia serveriui
 * (/api/push/register). Web naršyklėje nieko nedaro (isNativePlatform=false).
 * Paspaudus pranešimą — nuveda į data.url (pvz. /meistras).
 */
export default function PushRegister() {
  const { status } = useSession();
  useEffect(() => {
    if (status !== 'authenticated') return;
    let cancelled = false;
    (async () => {
      try {
        const { Capacitor } = await import('@capacitor/core');
        if (!Capacitor.isNativePlatform() || cancelled) return;
        const { PushNotifications } = await import('@capacitor/push-notifications');

        let perm = await PushNotifications.checkPermissions();
        if (perm.receive === 'prompt' || perm.receive === 'prompt-with-rationale') {
          perm = await PushNotifications.requestPermissions();
        }
        if (perm.receive !== 'granted' || cancelled) return;

        await PushNotifications.removeAllListeners();
        await PushNotifications.addListener('registration', async (token) => {
          try {
            await fetch('/api/push/register', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ token: token.value, platform: 'android' }),
            });
          } catch {
            /* tylu — pabandys kitą kartą */
          }
        });
        await PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
          const url = action?.notification?.data?.url;
          if (typeof url === 'string' && url.startsWith('/')) window.location.href = url;
        });
        await PushNotifications.register();
      } catch {
        /* įskiepis nepasiekiamas / ne programėlė — praleidžiam */
      }
    })();
    return () => { cancelled = true; };
  }, [status]);

  return null;
}
